import { useTranslation } from "react-i18next";
import type { TranscriptionModeType } from "../../types";
import { FileUploadIndicator } from "../../../../../common/AudioRecognize/components/FileUploadIndicator";
import { TranscriptionProgressBar } from "../../../../../common/AudioRecognize/components/TranscriptionProgressBar";
import { AudioTranscriptionResult } from "../../../../../common/AudioRecognize/components/AudioTranscriptionResult";
import styles from "./styles.module.css";

interface Props {
  status: TranscriptionModeType;
  content: string;
  progress: number;
  fileName: string;
}

export const AudioTranscriptionLayout = ({
  status,
  content,
  progress,
  fileName,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {status === "loading" && (
        <FileUploadIndicator
          uploadInfo={t("audio_transcription.file_upload_info")}
        />
      )}

      {status === "ready" && <div className={styles.ready}>{content}</div>}

      {status === "processing" && (
        <TranscriptionProgressBar progress={progress} fileName={fileName} />
      )}

      {status === "success" && (
        <AudioTranscriptionResult content={content} hasCopyButton />
      )}

      {status === "failed" && (
        <div className={styles.error}>
          {t("audio_transcription.processing_file_error")}
        </div>
      )}

      {status === "error" && (
        <div className={styles.error}>
          {t("audio_transcription.upload_file_error")}
        </div>
      )}
    </div>
  );
};
